import React from 'react';

/** Visual vocabulary of the single decision (verdict) — same words everywhere. */
export const ACTION_STYLE = {
    AC:        { cls: 'border-emerald-500/60 bg-emerald-500/15 text-emerald-200', ring: 'border-emerald-500/40' },
    KUCUK_AC:  { cls: 'border-sky-500/60 bg-sky-500/15 text-sky-200',             ring: 'border-sky-500/40' },
    EMIR_KOY:  { cls: 'border-amber-500/60 bg-amber-500/15 text-amber-200',       ring: 'border-amber-500/40' },
    BEKLE:     { cls: 'border-slate-500/60 bg-slate-600/25 text-slate-200',       ring: 'border-slate-600' },
    KOVALAMA:  { cls: 'border-orange-500/50 bg-orange-500/10 text-orange-200',    ring: 'border-orange-500/30' },
};
export const EXPLOSION_STYLE = {
    HIGH: 'text-emerald-300', MEDIUM: 'text-amber-300', LOW: 'text-slate-300', NONE: 'text-slate-500', DONE: 'text-orange-300',
};

export const fmtPrice = (v) => {
    if (v === null || v === undefined) return '—';
    const n = Number(v);
    if (n >= 1000) return `$${n.toLocaleString('en-US', { maximumFractionDigits: 2 })}`;
    if (n >= 1) return `$${n.toLocaleString('en-US', { maximumFractionDigits: 4 })}`;
    return `$${Number(n.toPrecision(4)).toString()}`;
};

/** Small chip: "🔭 EMİR KOY" (+ direction when asked). */
export function VerdictChip({ v, withDir = false, size = 'sm', testId }) {
    if (!v) return null;
    const st = ACTION_STYLE[v.action] || ACTION_STYLE.BEKLE;
    const sz = size === 'lg' ? 'px-2.5 py-1 text-sm' : 'px-1.5 py-0.5 text-[10px]';
    return (
        <span data-testid={testId} data-action={v.action} className={`inline-flex items-center gap-1 border rounded-md font-black tracking-wide whitespace-nowrap ${sz} ${st.cls}`}>
            {v.emoji} {v.action_tr}{withDir ? ` · ${v.direction_tr}` : ''}
        </span>
    );
}

export function DirBadge({ v, size = 'sm' }) {
    if (!v) return null;
    const d = v.direction;
    const cls = d === 'long' ? 'bg-emerald-500/20 text-emerald-200' : d === 'short' ? 'bg-rose-500/20 text-rose-200' : 'bg-slate-600/40 text-slate-300';
    const sz = size === 'lg' ? 'px-2 py-0.5 text-xs' : 'px-1.5 py-0.5 text-[10px]';
    return <span className={`rounded-md font-bold whitespace-nowrap ${sz} ${cls}`}>{v.direction_tr}{v.confidence ? ` · %${v.confidence}` : ''}</span>;
}

/** Banner for coin detail / alerts: the same three facts in one line + when + why. */
export function VerdictBanner({ v, symbol, testId = 'verdict-banner' }) {
    if (!v) return null;
    const st = ACTION_STYLE[v.action] || ACTION_STYLE.BEKLE;
    return (
        <div data-testid={testId} data-action={v.action} className={`rounded-lg border bg-slate-900/60 p-3 space-y-1.5 ${st.ring}`}>
            <div className="flex items-center gap-2 flex-wrap">
                <span className="text-[10px] uppercase tracking-wider text-slate-400">Karar</span>
                <VerdictChip v={v} size="lg" />
                <DirBadge v={v} size="lg" />
                <span className="text-xs text-slate-300" title={v.explosion_basis_tr || ''} data-testid={`${testId}-explosion`}>
                    Patlama ihtimali: <b className={EXPLOSION_STYLE[v.explosion]}>{v.explosion_label_tr || v.explosion_tr}</b>
                    {v.explosion_estimated && <span className="text-[10px] text-slate-500"> (tahmini)</span>}
                </span>
            </div>
            <div className="text-sm text-slate-100"><span className="text-slate-400">Ne zaman: </span>{v.when_tr}</div>
            {v.why_tr && <div className="text-xs text-slate-300"><span className="text-slate-500">Neden: </span>{v.why_tr}</div>}
            {v.explosion_basis_tr && v.explosion_pct != null && <div className="text-[11px] text-slate-500">Patlama %{v.explosion_pct} dayanağı: {v.explosion_basis_tr}</div>}
            {v.levels && (
                <div className="text-xs font-mono text-slate-200">
                    Giriş {fmtPrice(v.levels.entry)} · Zarar kes {fmtPrice(v.levels.stop)} ({v.levels.stop_pct}%) · Hedef {fmtPrice(v.levels.tp)} (+{v.levels.tp_pct}%) · {v.levels.leverage}
                </div>
            )}
        </div>
    );
}
